import { track } from '@fff-web/fff-analytics';
import { benefitNavigationLabels } from '../benefitNavigationLabels';

export enum CancelFlow {
  Accessed = 'Cancel Flow Accessed',
  Started = 'Cancel Flow Started',
  Completed = 'Cancel Flow Completed',
  Skipped = 'Cancel Flow Skipped',
}

export const eventCancelFlowStarted = (subscriptionType): Promise<void> =>
  track({
    trackName: CancelFlow.Started,
    properties: {
      cta_name: benefitNavigationLabels.NEXT,
      cancel_type: `${
        subscriptionType.charAt(0) + subscriptionType.slice(1).toLowerCase()
      } Subscription`,
    },
  });

export const eventCancelFlowAccessed = (properties): Promise<void> =>
  track({ trackName: CancelFlow.Accessed, properties });

export const eventCancelFlowCompleted = (properties): Promise<void> =>
  track({ trackName: CancelFlow.Completed, properties });

export const eventCancelFlowSkipped = (properties): Promise<void> =>
  track({ trackName: CancelFlow.Skipped, properties });
